import React, {useEffect, useRef, useState} from 'react'
import {Dropdown, InputDefault} from '../../../../components/ui'
import {FieldArray, FormikProvider, useFormik} from 'formik'
import {useQuery} from 'react-query'
import {getListRewardsNotValue0} from '../../../../modules/services/rewards.service'
import {Link} from 'react-router-dom'
import {
  getDepartment,
  getListProducts,
  getcustomerState,
} from '../../../../modules/services/product.service'
import {toast} from 'react-toastify'
import {getConfigDetail} from '../../../../modules/services/configs.service'

interface Props {
  handleChange: (e: any) => void
  id?: string
  initLoad?: any
  loadings?: any
}

const FormCampaigns: React.FC<Props> = ({handleChange, id, initLoad, loadings}) => {
  const resetForms = useRef<any>(null)
  const [category, setCategory] = useState(id ? initLoad.category : null)
  const [rewardsType, setRewardsType] = useState(null),
    [maxBudget, setMaxBudget] = useState(0),
    [totalEstimate, setTotalEstimate] = useState(0)
  const {data: rewardsValue} = useQuery(
    ['getRewadsNotValue0'],
    async () => await getListRewardsNotValue0()
  )
  const {data: product} = useQuery(['getProduct'], async () => await getListProducts())
  const {data: department} = useQuery(['getDepartment'], async () => await getDepartment())
  const {data: cstate} = useQuery(['getCstate'], async () => await getcustomerState())
  const {data: confPoint, isLoading: isLoadPoint} = useQuery(
    ['getConfig', '1'],
    async () => await getConfigDetail('1')
  )

  const CategoryMaster = [
    {label: 'Point', value: 'points'},
    {label: 'Rewards', value: 'rewards'},
  ]

  const PointMaster = [
    {label: 'Extra Point', value: 'extra point'},
    {label: 'Discount Point', value: 'discount point'},
  ]

  const sisMaster = [
    {label: 'Times', value: 'times'},
    {label: 'Currency', value: 'currency'},
  ]

  const sasMaster = [
    {label: 'Fix', value: 'fix'},
    {label: '%', value: '%'},
  ]

  const initValue = {
    campaignName: '',
    description: ' ',
    category: '',
    rewardsType: '',
    rewardList: [],
    point: '',
    pointType: '',
    attributes: {
      birthDate: false,
      activedstatus: false,
      registerdate: false,
      newMember: false,
      points: false,
      settingPoints: 0,
    },
    rewards: [
      {
        id: '',
      },
    ],
    transactions: [
      {
        id: '',
      },
    ],
    isTimePeriod: false,
    isMaxCapMember: false,
    isGlobalMaxCap: false,
    startDate: '',
    endDate: '',
    member_cap: {
      maxMemberCap: '',
      maxMemberCapType: '',
    },
    global_cap: {
      maxGlobalCap: '',
      maxGlobalCapType: '',
    },
    department: '',
    self_care: '',
  }

  const formik = useFormik({
    initialValues: id ? initLoad : initValue,
    onSubmit: (values, {resetForm}) => {
      handleChange(values)
    },
    enableReinitialize: true,
  })

  useEffect(() => {
    if (
      formik.values.rewards !== '' &&
      formik.values.rewards !== undefined &&
      isLoadPoint === false
    ) {
      let total = 0
      formik.values.rewards.forEach((item: any) => {
        const find = rewardsValue?.find((e: any) => e.value == item.id)
        if (find !== undefined) {
          const totalPoint = parseInt(find?.stock) * parseInt(find?.point)
          total += totalPoint
        }
      })
      setTotalEstimate(total * parseInt(confPoint?.attributes.conversion_currency))
    }
  }, [formik.values.rewards])
  return (
    <FormikProvider value={formik}>
      <form onSubmit={formik.handleSubmit} ref={resetForms}>
        <div className='d-flex flex-row align-items-start gap-4'>
          <div className='mb-3 w-100'>
            <label htmlFor='campaignName' className='form-label'>
              Campaign Name
            </label>
            <InputDefault
              type='text'
              id='campaignName'
              name='campaignName'
              onChange={formik.handleChange}
              value={formik.values.campaignName}
            />
            <label htmlFor='description' className='form-label'>
              Desciption
            </label>
            <InputDefault
              type='text'
              id='description'
              name='description'
              onChange={formik.handleChange}
              value={formik.values.description}
            />
            <label htmlFor='category' className='form-label'>
              Category
            </label>
            <Dropdown
              id={'category'}
              data={CategoryMaster}
              onChanges={(e) => {
                formik.setFieldValue('category', e.target.value)
                setCategory(e.target.value)
              }}
              value={formik.values.category}
            />
            <div className='d-flex flex-row justify-content-between gap-4 mt-3'>
              <label htmlFor='rewardsType' className='form-label'>
                Rewards
              </label>
              <Link to={'/rewards-catalog/create'}>
                <button className='btn btn-sm btn-color-muted btn-active btn-active-primary active px-4 me-1 mb-1'>
                  Create Rewards
                </button>
              </Link>
            </div>
            <Dropdown
              id={'rewardsType'}
              data={category === 'points' ? PointMaster : rewardsValue!}
              onChanges={(e) => {
                formik.setFieldValue('rewardsType', e.target.value)
                setRewardsType(e.target.value)
              }}
              value={formik.values.rewardsType}
            />
            <label htmlFor='attributes' className='form-label mt-3'>
              Condition{' '}
              {rewardsType === 'discount point' && (
                <span className='text-danger'>*Estimate budget {totalEstimate}</span>
              )}
            </label>
            {category === 'rewards' || rewardsType === 'extra point' ? (
              <>
                {/* <label className='form-check form-check-custom form-check-solid align-items-start'>
                    <input
                      className='form-check-input me-3'
                      type='checkbox'
                      name='birthDate'
                      onChange={(e) => formik.setFieldValue('attributes.birthDate', e.target.checked)}
                      defaultChecked={formik.values.attributes.birthDate} 
                    />
                    <span className='form-check-label d-flex flex-column align-items-start'>
                      <span className=' fs-6 mb-5'>Birth Date </span>
                    </span>
                  </label> */}
                {/* <label className='form-check form-check-custom form-check-solid align-items-start'>
                    <input
                      className='form-check-input me-3'
                      type='checkbox'
                      name='activedstatus'
                      onChange={(e) => formik.setFieldValue('attributes.activedstatus', e.target.checked)}
                      defaultChecked={formik.values.attributes.activedstatus} 
                    />
                    <span className='form-check-label d-flex flex-column align-items-start'>
                      <span className=' fs-6 mb-5'>Actived Status</span>
                    </span>
                  </label> */}
                {category === 'rewards' && (
                  <>
                    {/* <label className='form-check form-check-custom form-check-solid align-items-start'>
                      <input
                        className='form-check-input me-3'
                        type='checkbox'
                        name='registerdate'
                        onChange={(e) => formik.setFieldValue('attributes.registerdate', e.target.checked)}
                        defaultChecked={formik.values.attributes.registerdate} 
                      />
                      <span className='form-check-label d-flex flex-column align-items-start'>
                        <span className=' fs-6 mb-5'>Register Date</span>
                      </span>
                    </label> */}
                    <label className='form-check form-check-custom form-check-solid align-items-start'>
                      <input
                        className='form-check-input me-3'
                        type='checkbox'
                        name='newMember'
                        onChange={(e) =>
                          formik.setFieldValue('attributes.newMember', e.target.checked)
                        }
                        defaultChecked={formik.values.attributes.newMember}
                      />
                      <span className='form-check-label d-flex flex-column align-items-start'>
                        <span className=' fs-6 mb-5'>New Member</span>
                      </span>
                    </label>
                    {/* <label className='form-check form-check-custom form-check-solid align-items-start'>
                     <input
                       className='form-check-input me-3'
                       type='checkbox'
                       name='points'
                       onChange={(e) => formik.setFieldValue('attributes.points', e.target.checked)}
                       defaultChecked={formik.values.attributes.points} 
                     />
                     <span className='form-check-label d-flex flex-column align-items-start'>
                       <span className=' fs-6 mb-5'>Point</span>
                     </span>
                    </label> */}
                    {/* <label htmlFor='settingPoints' className='form-label'>
                         Setting Point
                       </label>
                      <InputDefault disabled={!formik.values.attributes.points}  type="number" id='settingPoints' name="settingPoints" onChange={(e) => formik.setFieldValue('attributes.settingPoints', e.target.value)} value={formik.values.attributes.settingPoints} /> */}
                  </>
                )}
              </>
            ) : null}
            {category === 'points' && rewardsType === 'extra point' ? (
              <>
                <FieldArray
                  name='transactions'
                  render={(arrayHelpers) => (
                    <>
                      {formik.values.transactions.map((e: any, i: any) => (
                        <div className='d-flex flex-row align-items-center py-0.5' key={i}>
                          <Dropdown
                            id={`transactions[${i}].id`}
                            name={`transactions[${i}].id`}
                            data={product}
                            onChanges={formik.handleChange}
                            value={formik.values.transactions[i].id}
                          />
                          <div className='col-lg-6 fv-row m-4'>
                            {i !== 0 && (
                              <button
                                className='btn btn-danger'
                                type='button'
                                onClick={() => arrayHelpers.remove(i)}
                              >
                                -
                              </button>
                            )}
                          </div>
                        </div>
                      ))}
                      <button
                        className='btn btn-success my-2'
                        onClick={() => arrayHelpers.push({id: ''})}
                        type='button'
                      >
                        +
                      </button>
                    </>
                  )}
                />
              </>
            ) : null}
            {category === 'points' && rewardsType === 'discount point' ? (
              <>
                <FieldArray
                  name='rewards'
                  render={(arrayHelpers) => (
                    <>
                      {formik.values.rewards.map((e: any, i: any) => {
                        return (
                          <div className='d-flex flex-row align-items-center py-0.5' key={i}>
                            <Dropdown
                              id={`rewards[${i}].id`}
                              name={`rewards[${i}].id`}
                              data={rewardsValue}
                              onChanges={formik.handleChange}
                              value={formik.values.rewards[i].id}
                            />
                            <div className='col-lg-6 fv-row m-4'>
                              {i !== 0 && (
                                <button
                                  className='btn btn-danger'
                                  type='button'
                                  onClick={() => arrayHelpers.remove(i)}
                                >
                                  -
                                </button>
                              )}
                            </div>
                          </div>
                        )
                      })}
                      <button
                        className='btn btn-success my-2'
                        onClick={() => arrayHelpers.push({id: ''})}
                        type='button'
                      >
                        +
                      </button>
                    </>
                  )}
                />
              </>
            ) : null}
            <br />
            {category === 'points' && (
              <>
                <label htmlFor='point' className='form-label'>
                  Point
                </label>
                <div className='d-flex flex-row align-items-center gap-4 mb-3'>
                  <InputDefault
                    type='text'
                    id='point'
                    name='point'
                    onChange={formik.handleChange}
                    value={formik.values.category === 'rewards' ? 0 : formik.values.point}
                    disabled={formik.values.category === 'rewards' && true}
                  />
                  <Dropdown
                    data={sasMaster}
                    id='pointType'
                    name='pointType'
                    onChanges={formik.handleChange}
                    value={formik.values.category === 'rewards' ? 'fix' : formik.values.pointType}
                    disabled={formik.values.category === 'rewards' && true}
                  />
                </div>
              </>
            )}
          </div>
          <div className='mb-3 w-100'>
            <label htmlFor='' className='form-label'>
              Department
            </label>
            <Dropdown
              data={department}
              id='department'
              name='department'
              onChanges={(e) => {
                const findbudget = department?.find((item: any) => item.value == e.target.value)
                setMaxBudget(findbudget?.budget)
                formik.setFieldValue('department', e.target.value)
              }}
              value={formik.values.department}
            />
            <label htmlFor='' className='form-label mt-2'>
              Customer State
            </label>
            <Dropdown
              data={cstate}
              id='self_care'
              name='self_care'
              onChanges={formik.handleChange}
              value={formik.values.self_care}
            />
            <label htmlFor='date' className='form-label mt-2'>
              Advice Setting
            </label>
            <label className='form-check form-check-custom form-check-solid align-items-start'>
              <input
                className='form-check-input me-3'
                type='checkbox'
                name='isTimePeriod'
                onChange={formik.handleChange}
                defaultChecked={formik.values.isTimePeriod}
              />
              <span className='form-check-label d-flex flex-column align-items-start'>
                <span className=' fs-6 mb-5'>with Time Period</span>
              </span>
            </label>
            <div className='d-flex flex-row align-items-center gap-4'>
              <label htmlFor='startDate' className='form-label'>
                Start Date
              </label>
              <InputDefault
                type='date'
                id='startDate'
                name='startDate'
                onChange={formik.handleChange}
                value={formik.values.startDate}
              />
              <label htmlFor='endDate' className='form-label'>
                End Date
              </label>
              <InputDefault
                type='date'
                id='endDate'
                name='endDate'
                onChange={formik.handleChange}
                value={formik.values.endDate}
              />
            </div>
            <label className='form-check form-check-custom form-check-solid align-items-start'>
              <input className='form-check-input me-3' type='checkbox' />
              <span className='form-check-label d-flex flex-column align-items-start'>
                <span className=' fs-6 mb-5'>Time Less</span>
              </span>
            </label>

            <label className='form-check form-check-custom form-check-solid align-items-start'>
              <input
                className='form-check-input me-3'
                type='checkbox'
                name='isMaxCapMember'
                onChange={formik.handleChange}
                defaultChecked={formik.values.isMaxCapMember}
              />
              <span className='form-check-label d-flex flex-column align-items-start'>
                <span className=' fs-6 mb-5'>with max Cap per Member</span>
              </span>
            </label>
            <label htmlFor='reward' className='form-label'>
              Max Cap (per Member)
            </label>
            <div className='d-flex flex-row align-items-center gap-4 mb-3'>
              <InputDefault
                type='text'
                id='member_cap.maxMemberCap'
                name='member_cap.maxMemberCap'
                onChange={(e) =>
                  formik.setFieldValue('member_cap.maxMemberCap', parseInt(e.target.value))
                }
                value={formik.values.member_cap.maxMemberCap}
              />
              <Dropdown
                data={sisMaster}
                id='member_cap.maxMemberCapType'
                name='member_cap.maxMemberCapType'
                onChanges={formik.handleChange}
                value={formik.values.member_cap.maxMemberCapType}
              />
            </div>
            <label className='form-check form-check-custom form-check-solid align-items-start'>
              <input
                className='form-check-input me-3'
                type='checkbox'
                name='isGlobalMaxCap'
                onChange={formik.handleChange}
                defaultChecked={formik.values.isGlobalMaxCap}
              />
              <span className='form-check-label d-flex flex-column align-items-start'>
                <span className=' fs-6 mb-5'>with Globa Max Cap</span>
              </span>
            </label>
            <label htmlFor='reward' className='form-label'>
              Global Max Cap
            </label>
            <div className='d-flex flex-row align-items-center gap-4'>
              <InputDefault
                type='number'
                id='global_cap.maxGlobalCap'
                name='global_cap.maxGlobalCap'
                onChange={(e) => {
                  if (maxBudget === 0 || maxBudget === null)
                    return toast.error('Please select department')
                  if (parseInt(e.target.value) > maxBudget) {
                    toast.error('Exceeds the maximum budget')
                  }
                  formik.setFieldValue('global_cap.maxGlobalCap', parseInt(e.target.value))
                }}
                value={formik.values.global_cap.maxGlobalCap}
              />
              <Dropdown
                data={sisMaster}
                id='global_cap.maxGlobalCapType'
                name='global_cap.maxGlobalCapType'
                onChanges={formik.handleChange}
                value={formik.values.global_cap.maxGlobalCapType}
              />
            </div>
          </div>
        </div>
        <div className='card-footer d-flex justify-content-end py-6 px-9'>
          {!loadings ? (
            <button className='btn btn-primary' data-bs-target='#add-edit-member' type='submit'>
              Submit
            </button>
          ) : (
            <button className='btn btn-primary' data-kt-indicator='on' type='button'>
              <span className='indicator-progress'>
                Please wait...
                <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
              </span>
            </button>
          )}
        </div>
      </form>
    </FormikProvider>
  )
}

export default FormCampaigns
